import { Outlet, createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

export const Route = createFileRoute('/_app/developers/webhooks')({
  component: WebhooksLayout,
});

function WebhooksLayout(): JSX.Element {
  return <Outlet />;
}
